__turbopack_context__.v({
  "tooltip": "LabsChip-module__B7F-aG__tooltip",
});
